import React from "react";
import { Container, Row } from "react-bootstrap";

import evaluationResultLabelService from "presentation/services/evaluation-result-labels";
import evaluationResultLabelTermsService from "presentation/services/evaluation-result-label-terms";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import EvaluationResultLabelForm from 'presentation/pages/evaluation-result-labels/elements/form';

import {
  mountItems
} from 'presentation/pages/evaluation-result-labels/functions/evaluation-result-label-terms';


class EvaluationResultLabelEdit extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      form: {},
      totalItems: 1,
      rawDaysOfWeek: [],
      evaluationResultLabelTerms: [],
      actionLoading: false,
      error: false,
      message: '',
    };
    this.loadData = this.loadData.bind(this);

  }

  async componentDidMount() {
    const { id } = this.props.match.params
    await this.loadData(id);
  }

  loadData = async (id) => {
    await evaluationResultLabelTermsService.search({ evaluationResultLabelId: [id] }).then(async (resultItems) => {
      await evaluationResultLabelService.findById(id).then((result) => {

        var orderedItems = resultItems.sort((a, b) => a.numericRangeStart - b.numericRangeStart);
        let relatedItems = [];

        for (let i = 0; i < orderedItems.length; i++) {
          let relatedItem = orderedItems[i];
          relatedItem.key = i + 1;
          relatedItems.push(relatedItem);
        }

        let totalItems = relatedItems.length > 0 ? relatedItems.length : 1;

        this.setState({ form: result, evaluationResultLabelTerms: relatedItems, totalItems: totalItems, loading: false }, () => mountItems(this));

      });


    });

  }

  goTo = (destination) => {
    const { history } = this.props;

    history.push(destination);
  };

  render() {
    let { loading, error, message, actionLoading, form } = this.state;

    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && (
          <Container>
            <Row>
              <EvaluationResultLabelForm
                loading={loading}
                error={error}
                form={form}
                component={this}
              />
            </Row>
          </Container>
        )
        }
      </div>
    );
  };
}

export default EvaluationResultLabelEdit;
